// AI-CONTEXT: See docs/features/analytics-card-redesign.md
//
// Pure status-pill logic for the effect ScoreBlock:
//   - "+X% boven benchmark" / "X% onder benchmark" vs the benchmark growth.
// Pills only make sense once there is a measured result, so everything is
// suppressed when `result` is not a finite number.

/**
 * @typedef {object} ScorePill
 * @property {'bench'} kind - Styling variant (bench = benchmark delta)
 * @property {boolean} [positive] - true when at/above the benchmark (styled green), false when below (red)
 * @property {string} label - Display text
 */

const round1 = (v) => Math.round(v * 10) / 10
const isNum = (v) => typeof v === 'number' && Number.isFinite(v)

/**
 * Build the status pills shown next to the hero result.
 *
 * @param {object} params
 * @param {number | null} params.result - Measured growth %; pills are empty when this is null/NaN
 * @param {number | null} [params.bench] - Benchmark growth %; benchmark pill shows the signed delta
 * @returns {ScorePill[]}
 */
const getScorePills = ({ result, bench = null }) => {
    if (!isNum(result)) return []

    /** @type {ScorePill[]} */
    const pills = []

    if (isNum(bench)) {
        const delta = round1(result - bench)
        const positive = delta >= 0
        const sign = positive ? '+' : ''
        const side = positive ? 'boven' : 'onder'
        pills.push({ kind: 'bench', positive, label: `${sign}${delta}% ${side} benchmark` })
    }

    return pills
}

export default getScorePills
